#import "../fragments/accounts-for-lead-fragment.graphql"

query GetAccountsForLead($leadId: ID!) {
    lead(id: $leadId) {
        ...AccountsForLeadFragment
    }
}
